import React, { useState } from 'react'
import { PopupModal } from 'react-calendly'
import clsx from 'clsx'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import styles from './styles.module.scss'
import { iPhoneScrollFix } from '../../quotes/experiences/search-app-start/iPhoneScrollFix'

type CalendlyWidgetProps = {
  popupText: string
  calendlyUrl: string
  externalStyles?: string
}

const CalendlyWidget = ({
  popupText,
  calendlyUrl,
  externalStyles,
}: CalendlyWidgetProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOnClick = () => {
    iPhoneScrollFix()
    disableBodyScroll(window.document && window.document.body)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    clearAllBodyScrollLocks()
  }

  return (
    <>
      <div
        className={clsx(styles.popupText, externalStyles)}
        onClick={handleOnClick}
        data-test-id="CalendlyWidget"
      >
        {popupText}
      </div>
      {typeof window !== 'undefined' && window.document && (
        <PopupModal
          url={calendlyUrl}
          onModalClose={handleClose}
          open={isOpen}
          /*
          * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
          * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
          */
          rootElement={window.document.body}
        />
      )}
    </>
  )
}

export default CalendlyWidget
